<template>
	<div class="fiscal-status-filter-container" :class="{active: active}" @click="$emit('toggle')">
		<div class="icon-badge" :class="color" v-html="svgStore.get('iconAde')"></div>
	</div>
</template>

<script>
import {useSvgStore} from "@/shared/stores";

export default {
	setup() {
		const svgStore = useSvgStore();
		return { svgStore }
	},
	name: "FiscalStatusFilter",
	props: {
		color: {
			type: String,
			required: true,
			validator: value => ['grey', 'red', 'orange'].includes(value)
		},
		active: {
			type: Boolean,
			default: false
		}
	}
}
</script>

<style lang="scss" scoped>
.fiscal-status-filter-container {
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	border: 1px solid $primary;
	border-radius: 13px;
	cursor: pointer;
	width: 40px;
	height: 40px;
	background-color: transparent;
	transition: background-color 0.3s ease-in-out;

	@media (max-width: 340px) {
		width: 36px;
		height: 36px;
	}

	* {
		pointer-events: none;
		user-select: none;
	}

	.icon-badge {
		border-radius: 13px;
		padding: 5px;
		display: flex;
		align-items: center;
		justify-content: center;
		width: 24px;
		height: 24px;

		@media (max-width: 340px) {
			width: 20px;
			height: 20px;
		}

		:deep(svg) {
			width: 100%;
			height: 100%;

			.fill {
				fill: white;
			}
		}

		&.grey {
			background-color: #828282;
			opacity: 0.8;
		}

		&.red {
			background-color: #E24B74;
		}

		&.orange {
			background-color: #F7931E;
		}
	}

	&.active {
		background-color: var(--color-active-button);
	}
}
</style>
